module.exports = __webpack_public_path__ + "static/img/up.1158efa2.svg";